import { CaseReminderScope, CaseReminderSummaryDocument } from '@gql'
import { useQuery } from '@hooks/graphql'
import useUser from '@hooks/useUser'
import { hasOwnReminders } from '@sections/cases/utils/reminderScopes'

/** Refresh cadence for the badge — a count, not a live feed (the due push refetches it too). */
const POLL_INTERVAL_MS = 60_000

/**
 * The operator's own overdue reminders, for the red nav badge. 0 — and no
 * query — for anyone who works no cases of their own.
 */
export function useReminderBadgeCount(): number {
  const { user } = useUser()
  const { data } = useQuery(CaseReminderSummaryDocument, {
    // A failed poll keeps the last count; the badge is a hint, not a gate.
    errorPolicy: 'ignore',
    fetchPolicy: 'cache-and-network',
    pollInterval: POLL_INTERVAL_MS,
    skip: !hasOwnReminders(user),
    variables: { scope: CaseReminderScope.MINE },
  })

  return data?.caseReminderSummary.overdue ?? 0
}

export default useReminderBadgeCount
